import React, { Component } from 'react';
import { FormField, TextFieldLabel, Label, ErrorMessage } from '../../../styles/style';
import * as styled from '../../../styles/style';

class SelectField extends Component {
  render() {
    let { value, values, name, update, label, labels, required, errorMessage } = this.props;

    if (labels) {
      values = Object.keys(values).map(key => values[key]);
    }

    if (!value) {
      value = "";
    }

    return (
      <div>
        {label && (
          <TextFieldLabel>
            <Label required={required} htmlFor={name}>{label}</Label>
            {errorMessage && (<ErrorMessage>{errorMessage[name]}</ErrorMessage>)}
          </TextFieldLabel>
        )}
        <styled.Select onChange={update} value={value} id={name} name={name}>
          <option></option>
          {values.map((value, index) => {
            return <option key={index} value={value}>{labels ? labels[index] : value}</option>
          })};
        </styled.Select>
      </div>
    )
  }
}

export default SelectField;
